import {until} from 'lit-html/directives/until';
import {rosterErrors} from '../../../../modules/constants-enumerate';
import {rosterErrorLabels} from '../../../../modules/i18n-labels';

export default (ctx, html) => html`
<p class="text-danger text-center">${until(ctx.__('<tt-uzl+xkYu>', 'Please correct the following rows in your CSV and reupload your updated CSV'))}</p>
<div class="row">
  ${ctx.errors.map((error) => html`
    ${error.type === rosterErrors.CSV_INVALID_COLUMN_COUNT? html`
    <div class="col-sm-6 col-md-4 mb-3">
      <div class="card card-border-color-left card-border-color-warning">
      <div class="card-header">
        <div>${until(rosterErrorLabels[error.type])}</div>
        <div class="font-weight-bold">${until(ctx.__('<tt-6xMAkn+L>', 'Row'))} ${error.payload.line}</div>
      </div>
        <p class="card-body">
          ${until(ctx.__('<tt-30hvNnCJ>', 'If you want to use our template,'))} <a class="cursor-pointer text-blue" @click="${ctx.getRosterTemplate}">${until(ctx.__('<tt-hp4Ph2J1>', 'download it here'))}</a>.
        </p>
      </div>
    </div>
    `: ''}
  `)}
  </div>`;
